<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import VehicleList from './VehicleList.svelte';
    import IconAdd from '../../shared/Icons/IconAdd.svelte';
    import { currentMainFilter } from '../../../stores/filter';
    import FilterVehicles from '../Filter/FilterVehicles.svelte';
    import { debug, mainMenu } from '../../../stores/store';
    import Separator from '../../shared/Separator.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import FilterWarehouses from '../Filter/FilterWarehouses.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import { features } from '../../shared/Features/features';
    import { openModal } from 'svelte-modals';
    import ModalCustom from '../../shared/Modals/ModalCustom.svelte';
    import ModalAddManyVehicles from './ModalAddManyVehicles.svelte';
    import ButtonSmallBlue from '../../shared/ButtonSmallBlue.svelte';
    import { VehiclesApi } from './VehiclesApi';
    import { api } from '../../../stores/api';
    import { vehiclesManager } from './VehiclesApp/vehiclesManager';
    import ButtonSmallDanger from '../../shared/ButtonSmallDanger.svelte';
    import Switch from '../../shared/Switch.svelte';
    import Tabs from '../../shared/Tabs.svelte';
    let addMode = false;
    let letAddVehicle: boolean = false;
    let showFilter: boolean = false;
    let changeCounter: number = 0;
    let selectedViewId: string = 'vehicle';
    let vehicleCount: number = 0;

    function onVehicleCountChange(count: number) {
        if (count != vehicleCount) {
            if (vehicleCount >= 0) {
                if ($features.feature_ux_improvements) {
                    let pageVehiclesItem = $mainMenu.items.find((i) => i.id == 'PageVehicles');
                    if (pageVehiclesItem?.notification) {
                        pageVehiclesItem.notification.reload = true;
                        $mainMenu = $mainMenu;
                    }
                }
            }
            vehicleCount = count;
        }
    }

    onMount(() => {
        $mainMenu.currentPage = 'PageVehicles';
        $currentMainFilter = FilterVehicles;
        return () => {
            $currentMainFilter = null;
        };
    });
</script>

<TemplateStandard>
    <div slot="submenu">
        {#if $features?.feature_vehicle_groups}
            <div style="display: flex; flex-direction: row; justify-content: flex-end;">
                <div style="margin: 10px 20px; min-width: 260px;">
                    <Tabs
                        selectedId={selectedViewId}
                        items={[
                            { id: 'vehicle', label: $_('Vehicles') },
                            { id: 'vehicle_group', label: $_('vehicle_group_label') },
                        ]}
                        onChange={id => {
                            // addMode = false;
                            selectedViewId = id;
                        }}
                    />
                </div>
            </div>
        {/if}
    </div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                {#if $features?.feature_vehicle_groups === false}
                    {$_('Vehicles')}
                {/if}
            </div>
            <div slot="main-search">
                {#if !addMode && showFilter}
                    <FilterVehicles />
                {/if}
            </div>
            <div slot="main-buttons">
                <div style="display: flex; justify-content: flex-end;">
                    {#if selectedViewId === 'vehicle_group'}
                        {#if letAddVehicle}
                            <ButtonAddSomething
                                on:click={() => {
                                    addMode = !addMode;
                                }}
                                text={$_('Add vehicle group')}
                            />
                        {/if}
                    {/if}
                    {#if selectedViewId === 'vehicle'}
                        {#if letAddVehicle}
                            <ButtonAddSomething
                                on:click={() => {
                                    addMode = !addMode;
                                }}
                                text={$_('Add vehicle')}
                            />
                        {/if}
                        {#if $features?.feature_create_many_auto_vehicles}
                            <ButtonAddSomething
                                on:click={() => {
                                    openModal(ModalAddManyVehicles, {
                                        onCreate: () => {
                                            changeCounter += 1;
                                            console.log('Vehicles created', changeCounter);
                                        },
                                    });
                                }}
                                text={$_('Dodaj wiele pojazdów')}
                            />
                        {/if}
                        {#if $debug}
                            <ButtonSmallBlue
                                text="Colorize"
                                on:click={() => {
                                    VehiclesApi.colorize($api)
                                        .then(_ => {
                                            $vehiclesManager.reset();
                                            changeCounter += 1;
                                        })
                                        .catch(error => {
                                            console.error('Error colorizing vehicles:', error);
                                        });
                                }}
                            />
                            <ButtonSmallDanger
                                text="Remove all"
                                on:click={() => {
                                    VehiclesApi.removeAll($api)
                                        .then(_ => {
                                            $vehiclesManager.reset();
                                            changeCounter += 1;
                                        })
                                        .catch(error => {
                                            console.error('Error removing all vehicles:', error);
                                        });
                                }}
                            />
                        {/if}
                    {/if}
                </div>
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
        <div
            style="margin: 20px 0; overflow-y: auto; flex: 1; display: flex; flex-direction: column;"
        >
            {#if selectedViewId === 'vehicle'}
                <VehicleList
                    bind:addMode
                    bind:letAddVehicle
                    writableMode={true}
                    compactMode={false}
                    onSelect={() => {}}
                    bind:showFilter
                    {changeCounter}
                    is_group={false}
                    onCountChange={onVehicleCountChange}
                />
            {/if}
            {#if selectedViewId === 'vehicle_group'}
                <VehicleList
                    bind:addMode
                    bind:letAddVehicle
                    writableMode={true}
                    compactMode={false}
                    onSelect={() => {}}
                    bind:showFilter
                    {changeCounter}
                    is_group={true}
                    onCountChange={onVehicleCountChange}
                />
            {/if}
        </div>
    </div>
</TemplateStandard>

<style>
</style>
